/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListChallengeLiveNotifications200ResponseSchema } from '../models/ListChallengeLiveNotifications200ResponseSchema';
import type { ListChallengeLiveNotificationsRequestSchema } from '../models/ListChallengeLiveNotificationsRequestSchema';
import type { SendChallengeLiveNotification200ResponseSchema } from '../models/SendChallengeLiveNotification200ResponseSchema';
import type { SendChallengeLiveNotificationRequestSchema } from '../models/SendChallengeLiveNotificationRequestSchema';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LiveNotificationsService {

    /**
     * sendChallengeLiveNotification
     * list Challenge live notifications
     * @param requestBody
     * @returns SendChallengeLiveNotification200ResponseSchema SendChallengeLiveNotification200Response
     * @throws ApiError
     */
    public static sendChallengeLiveNotification(
        requestBody?: SendChallengeLiveNotificationRequestSchema,
    ): CancelablePromise<SendChallengeLiveNotification200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/sendChallengeLiveNotification',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `SendChallengeLiveNotification400Response`,
            },
        });
    }

    /**
     * listChallengeLiveNotifications
     * list Challenge live notifications
     * @param requestBody
     * @returns ListChallengeLiveNotifications200ResponseSchema ListChallengeLiveNotifications200Response
     * @throws ApiError
     */
    public static listChallengeLiveNotifications(
        requestBody?: ListChallengeLiveNotificationsRequestSchema,
    ): CancelablePromise<ListChallengeLiveNotifications200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/listChallengeLiveNotifications',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `ListChallengeLiveNotifications400Response`,
            },
        });
    }

}
